import {Component, Input} from '@angular/core';
import {AssistantSuggestionDto} from '../../../Models/Assistant/assistant-suggestion.interface';

@Component({
  selector: 'app-assistant-suggestion',
  templateUrl: './assistant-suggestion.component.html',
  styleUrls: ['./assistant-suggestion.component.scss'],
  standalone: false
})
export class AssistantSuggestionComponent {
  @Input() suggestion!: AssistantSuggestionDto;
}
